import { z } from "zod";
/**
 * The single error shape every endpoint returns.
 *
 * `code` is a stable English identifier the frontend can branch on; `message` is Spanish
 * (rioplatense), specific and actionable, because it is shown to the user. `requestId` is
 * repeated in the body so a screenshot is enough to find the log line — that is the whole point
 * of Story 7 criterion 3, and it only works if the id is visible without opening devtools.
 */
export const apiErrorSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        requestId: z.string(),
        details: z.unknown().optional(),
    }),
});
/** Stable error codes. The Spanish message lives at the throw site, next to its context. */
export const ERROR_CODES = {
    TENANT_NOT_FOUND: "TENANT_NOT_FOUND",
    TENANT_NOT_ACTIVE: "TENANT_NOT_ACTIVE",
    TENANT_CONTEXT_MISSING: "TENANT_CONTEXT_MISSING",
    CROSS_TENANT_ACCESS: "CROSS_TENANT_ACCESS",
    UNAUTHENTICATED: "UNAUTHENTICATED",
    FORBIDDEN: "FORBIDDEN",
    VALIDATION_FAILED: "VALIDATION_FAILED",
    UPLOAD_TOO_LARGE: "UPLOAD_TOO_LARGE",
    NOT_FOUND: "NOT_FOUND",
    RATE_LIMITED: "RATE_LIMITED",
    CONFLICT: "CONFLICT",
    SERVICE_UNAVAILABLE: "SERVICE_UNAVAILABLE",
    INTERNAL: "INTERNAL",
};
/** Header carrying the request id on every response, success or failure. */
export const REQUEST_ID_HEADER = "x-request-id";
//# sourceMappingURL=errors.js.map